import sessionStorageUtil from './sessionStorageUtil'
import qs from 'qs';
try {
  let tempQuery = qs.parse(window.location.href.split('?')[1]);
  // 小程序类型来源存储
  let miniType = tempQuery['appSign'];
  if (miniType) {
    sessionStorage.setItem('appSign', miniType);
  }
} catch(ex) {
  console.log(ex);
}
let os = '';
let browser = '';
let channel = '';
let channelHeader = "";
os = (function () {
  if (navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1) {
    return 'ANDROID';
  } else if (!navigator.userAgent.indexOf('iPhone') > -1) {
    return "IOS";
  } else {
    return '';
  }
})();
let isMogoRenter = function () {
  var userAgentInfo = navigator.userAgent.toLowerCase();
  return userAgentInfo.match(/MGRenter/i) 
  || userAgentInfo.match(/mgwebkit/i) 
  || (sessionStorage.getItem('appSign') && sessionStorage.getItem('appSign').toLowerCase() === 'mgwebkit');
};
// 浏览器枚举
var BrowserEnum = {
  // 银联
  UNIONPAY: 'unionpay',
  // 微信
  WEI_XIN: 'weixin',
  // 支付宝
  ALI: 'ali',
  //蘑菇租客app
  MGRenter: 'MGRenter',
  // 谷歌
  CHROME: 'chrome',
  // 苹果
  SAFARI: 'safari',
  // 浏览器
  BROWSER: 'browser'
};

browser = (function () {
  var userAgentInfo = navigator.userAgent.toLowerCase();
  if (userAgentInfo.match(/unionpay/i)) {
    return BrowserEnum.UNIONPAY;
  }
  if (userAgentInfo.match(/MGRenter/i) || userAgentInfo.match(/mgwebkit/i) || isMogoRenter()) {
    return BrowserEnum.MGRenter;
  }
  if (userAgentInfo.match(/micromessenger/i)) {
    return BrowserEnum.WEI_XIN;
  }
  if (userAgentInfo.match(/aliapp/i) && userAgentInfo.match(/alipayclient/i)) {
    return BrowserEnum.ALI;
  }
  if (userAgentInfo.match(/chrome/i)) {
    return BrowserEnum.CHROME;
  }
  if (userAgentInfo.match(/safari/i)) {
    return BrowserEnum.SAFARI;
  }
  return BrowserEnum.BROWSER;
})();
/**
 C端渠道枚举
 CHANNEL_0(0,"全部"),
 CHANNEL_1(1,"租客APP"),
 CHANNEL_2(2,"BS后台"),
 CHANNEL_3(3,"官网"),
 CHANNEL_4(4,"房东APP"),
 CHANNEL_5(5,"房东PC"),
 CHANNEL_6(6,"定时任务"),
 CHANNEL_7(7,"后台操作"),
 CHANNEL_8(8,"搜索引擎"),
 CHANNEL_9(9,"租户WAP"),
 CHANNEL_10(10,"租客微信公众号"),
 CHANNEL_11(11,"租客支付宝服务窗"),
 CHANNEL_12(12,"新伙伴APP"),
 CHANNEL_16(16,"房东微信公众号"),
 CHANNEL_17(17,"租客支付宝TP"),
 CHANNEL_18(18,"房东个人版"),
 CHANNEL_19(19,"拓展销售系统"),
 CHANNEL_20(20,"蘑菇开放平台"),
 CHANNEL_21(21,"房东个人市场版"),
 CHANNEL_22(22,"帕拉斯"),
 CHANNEL_23(23,"PayApi"),
 CHANNEL_30(30,"TeleAPI"),
 CHANNEL_35(35,"房东专属品牌定制链接"),
 CHANNEL_45(45,"房东权限"),
 CHANNEL_46(46,"lock"),
 CHANNEL_47(47,"VIC管理系统"),
 CHANNEL_48(48,"VIC房东H5"),
 CHANNEL_50(50,"租客VIC"),
 CHANNEL_51(51,"房东专属品牌定制-浏览器"),
 CHANNEL_52(52,"房东专属品牌定制-租客微信公众号"),
 CHANNEL_53(53,"房东专属品牌定制-租客支付宝服务窗"),
 CHANNEL_54(54,"银联第三方授权"),
 CHANNEL_56(56,"微信小程序"),
 CHANNEL_57(57,"支付宝小程序"),
 CHANNEL_71(71,"线上二维码微信扫码"),
 CHANNEL_72(72,"线上二维码支付宝扫码"),
 CHANNEL_73(73,"线上二维码其它扫码"),
 CHANNEL_74(74,"线下二维码微信扫码"),
 CHANNEL_75(75,"线下二维码支付宝扫码"),
 CHANNEL_76(76,"线下二维码其它扫码");
 */

const ChannelEnum = {
  BrandCustom: 35,
  // 银联
  UnionPay: 54,
  // 租客app
  App: 1,
  // 租客wap
  Wap: 9,
  // 微信公众号
  Weixin: 10,
  // 支付宝生活号
  Ali: 11,
  //支付宝小程序
  AliMini: 57,
  //微信小程序
  WeixinMini: 56
}
channel = (function () {
  if (sessionStorageUtil.get().landlordNo) {
    return ChannelEnum.BrandCustom;
  }
  switch (browser) {
    case BrowserEnum.UNIONPAY: return ChannelEnum.UnionPay;
    case BrowserEnum.MGRenter: return ChannelEnum.App
    case BrowserEnum.WEI_XIN: return ChannelEnum.Weixin;
    case BrowserEnum.ALI: return ChannelEnum.Ali;
    default: return ChannelEnum.Wap;
  }
})()

let OSAndVersion = (function () {
  let ua = navigator.userAgent;
  let osArr = [];
  if (ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
    osArr.push('IOS');
    osArr.push(ua.match(/OS (\d+)_(\d+)_?(\d+)?/).slice(1, 3).join('.'));
    return osArr.join('_');
  } else if (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) {
    let str = ua.match(/android [\d._]+/gi);
    return str.toString().replace(' ', '_');
  }
})();
OSAndVersion = OSAndVersion || "h5";

let isAliMini = function () {
  return (sessionStorage.getItem('appSign') === 'aliMiniProgram' || (browser === 'ali' && navigator.userAgent.indexOf('MiniProgram') > -1));
};
let isWxMini = function () {
  return (browser === BrowserEnum.WEI_XIN && navigator.userAgent.toLowerCase().indexOf('miniprogram') > -1);
};

channelHeader = (function () {
  if(isAliMini()) {
    return  ChannelEnum.AliMini
  }
  if(isWxMini()) {
    return  ChannelEnum.WeixinMini
  }
  switch (browser) {
    case BrowserEnum.UNIONPAY: return ChannelEnum.UnionPay;
    case BrowserEnum.MGRenter: return ChannelEnum.Wap
    case BrowserEnum.WEI_XIN: return ChannelEnum.Weixin;
    case BrowserEnum.ALI: return ChannelEnum.Ali;
    default: return ChannelEnum.Wap;
  }
})()

export default {
  os,
  browser,
  channel,
  channelHeader,
  BrowserEnum,
  ChannelEnum,
  isAliMini,
  isWxMini,
  OSAndVersion
};



// WEBPACK FOOTER //
// ./src/library/userAgentHelper.js